import React, {createContext} from 'react';
import PropTypes from 'prop-types';

const StoreContext = createContext();
const GlobalRegistryContext = createContext();
const CookiesContext = createContext();
const LoggerContext = createContext();

const AppContextProvider = ({children}, {store, globalRegistry, cookies, logger}) => {
  return (
    <StoreContext.Provider value={store}>
      <GlobalRegistryContext.Provider value={globalRegistry}>
        <CookiesContext.Provider value={cookies}>
          <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
        </CookiesContext.Provider>
      </GlobalRegistryContext.Provider>
    </StoreContext.Provider>
  );
};

AppContextProvider.contextTypes = {
  store: PropTypes.object,
  globalRegistry: PropTypes.object,
  cookies: PropTypes.object,
  logger: PropTypes.object,
};

const withStore = (WrappedComponent) => {
  function WithStore(props) {
    return <StoreContext.Consumer>{(store) => <WrappedComponent store={store} {...props} />}</StoreContext.Consumer>;
  }

  WithStore.displayName = `WithStore(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithStore;
};

const withGlobalRegistry = (WrappedComponent) => {
  function WithGlobalRegistry(props) {
    return (
      <GlobalRegistryContext.Consumer>
        {(globalRegistry) => <WrappedComponent globalRegistry={globalRegistry} {...props} />}
      </GlobalRegistryContext.Consumer>
    );
  }

  WithGlobalRegistry.displayName = `WithGlobalRegistry(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithGlobalRegistry;
};

const withCookies = (WrappedComponent) => {
  function WithCookies(props) {
    return (
      <CookiesContext.Consumer>
        {(cookies) => <WrappedComponent cookies={cookies} {...props} />}
      </CookiesContext.Consumer>
    );
  }

  WithCookies.displayName = `WithCookies(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithCookies;
};

const withLogger = (WrappedComponent) => {
  function WithLogger(props) {
    return (
      <LoggerContext.Consumer>{(logger) => <WrappedComponent logger={logger} {...props} />}</LoggerContext.Consumer>
    );
  }

  WithLogger.displayName = `WithLogger(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithLogger;
};

const compose = (...args) => {
  let cur = args.pop();
  return (child) => {
    return args.reduceRight((acc, fn) => fn(acc), cur(child));
  };
};

export {
  StoreContext,
  GlobalRegistryContext,
  CookiesContext,
  LoggerContext,
  compose,
  withStore,
  withLogger,
  withGlobalRegistry,
  withCookies,
};
export default AppContextProvider;
